import styled from 'styled-components';

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 100;
  margin: 10px;
  width: 400px;
  min-height: 100px;
  box-sizing: border-box;
  padding: 10px;
  background-color: ${(props) => props.backgroundColor || 'var(--color-white)'};
  color: ${(props) => props.color || 'var(--color-white)'};
  font-family: ${(props) => props.fontFamily || 'Source Sans Pro'};
  border-radius: 10px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    width: 300px;
  }
`;

export const BoldText = styled.span`
  font-weight: bold;
  font-size: 21px;
  text-align: center;
`;

export const Text = styled.span`
  font-size: medium;
  text-align: center;
`;

export const Spacer = styled.div`
  width: 100%;
  height: ${(props) => props.height || '20px'};
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;
